import { useLocation } from 'react-router-dom';
import { useAuth, useGraphQLQuery } from 'studio5/contexts';

import useIdentifier from './use-identifier';
import { GetAnalyticsTraitsQuery } from './__generated__/queries.types';
import { GET_ANALYTICS_TRAITS } from './queries';

export default () => {
  const [{ fetching, data }] = useGraphQLQuery<GetAnalyticsTraitsQuery>({
    query: GET_ANALYTICS_TRAITS,
  });

  const { isSpoofing } = useAuth();

  const { key: location } = useLocation();

  return useIdentifier({
    data,
    fetching,
    isSpoofing,
    location,
    onUserChange: (window as any).analytics?.identify,
    onGroupChange: (window as any).window.analytics?.group,
    onPageChange: (window as any).window.analytics?.page,
  });
};
